import { render, staticRenderFns } from "./re_inspec.vue?vue&type=template&id=dbf89686"
import script from "./re_inspec.vue?vue&type=script&lang=js"
export * from "./re_inspec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports